import { themeAtom } from "../../shared/atoms";
import { Bq5CargoArrangementsM } from "../models/bq5-cargo-arrangements.model";
import { useAtomValue } from "jotai";
import React from "react";
import { twMerge } from "tailwind-merge";

export function Bq5BWMS(
  form: Bq5CargoArrangementsM,
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void,
  toggleComments: (inputId: string) => void,
  isCommentsVisible: (inputId: string) => boolean,
  readonly: boolean,
) {
  const theme = useAtomValue(themeAtom);

  return (
    <div>
      <h2 className="mb-2 mt-[120px] text-lg font-semibold">Ballast Water Management Systems (BWMS)</h2>

      {/* D1 D2 */}
      <div className="mt-4 grid grid-cols-4 gap-4">
        <div className="col-span-1">
          <label className="block text-sm font-bold">
            Does the vessel comply with D1 or D2 performance standards?:
          </label>
          <select
            disabled={readonly}
            name="d1d2PerformanceStandard"
            value={form.d1d2PerformanceStandard}
            onChange={handleChange}
            className={twMerge("mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring")}
          >
            <option value=""></option>
            <option value="D1">D1</option>
            <option value="D2">D2</option>
          </select>
        </div>

        {/* BW Treatment System fitted? */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Ballast Water Treatment System fitted:</label>
          <div className="mt-1 flex space-x-4">
            <label className="inline-flex items-center">
              <input
                disabled={readonly}
                type="radio"
                name="bwTreatmentFitted"
                value="yes"
                checked={form.bwTreatmentFitted === "yes"}
                onChange={handleChange}
                className="form-radio"
              />
              <span className="ml-2">Yes</span>
            </label>
            <label className="inline-flex items-center">
              <input
                disabled={readonly}
                type="radio"
                name="bwTreatmentFitted"
                value="no"
                checked={form.bwTreatmentFitted === "no"}
                onChange={handleChange}
                className="form-radio"
              />
              <span className="ml-2">No</span>
            </label>
          </div>
          <label className="block text-sm font-bold text-gray-700">
            <button
              className={theme.balticQuestionnaire.blueText}
              onClick={() => toggleComments("bwTreatmentComments")}
            >
              Comments
            </button>
          </label>
          {(form.bwTreatmentComments || isCommentsVisible("bwTreatmentComments")) && (
            <textarea
              disabled={readonly}
              name="bwTreatmentComments"
              value={form.bwTreatmentComments}
              onChange={handleChange}
              className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
            />
          )}
        </div>
      </div>

      <div className="mt-4 grid grid-cols-4 gap-4">
        <div className="col-span-1">
          <label className="block text-sm font-bold">What type of BWTS?</label>
          <select
            disabled={readonly}
            name="bwtsType"
            value={form.bwtsType}
            onChange={handleChange}
            className={twMerge("mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring")}
          >
            <option value=""></option>
            <option value="UV Light">UV Light</option>
            <option value="Infrared">Infrared</option>
            <option value="Chemical">Chemical</option>
            <option value="Other (specify)">Other (specify)</option>
          </select>
        </div>

        <div className="col-span-1">
          <label className="block text-sm font-bold">If other, specify</label>
          <input
            disabled={readonly}
            type="text"
            name="bwtsOtherType"
            value={form.bwtsOtherType}
            onChange={handleChange}
            className={twMerge("mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring")}
          />
        </div>

        <div className="col-span-2">
          <label className="block text-sm font-bold">Name of BWTS manufacturer</label>
          <input
            disabled={readonly}
            type="text"
            name="bwtsManufacturer"
            value={form.bwtsManufacturer}
            onChange={handleChange}
            className={twMerge("mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring")}
          />
        </div>
      </div>

      <div className="mt-4 grid grid-cols-4 gap-4">
        <div className="col-span-2">
          <label className="block text-sm font-bold">Does BWTS have IMO type approval?</label>
          <div className="mt-1 flex space-x-4">
            <label className="inline-flex items-center">
              <input
                disabled={readonly}
                type="radio"
                name="bwtsHasIMOApproval"
                value="yes"
                checked={form.bwtsHasIMOApproval === "yes"}
                onChange={handleChange}
                className="form-radio"
              />
              <span className="ml-2">Yes</span>
            </label>
            <label className="inline-flex items-center">
              <input
                disabled={readonly}
                type="radio"
                name="bwtsHasIMOApproval"
                value="no"
                checked={form.bwtsHasIMOApproval === "no"}
                onChange={handleChange}
                className="form-radio"
              />
              <span className="ml-2">No</span>
            </label>
          </div>
        </div>

        <div className="col-span-2">
          <label className="block text-sm font-bold">Is BWTS of a USCG approved type?</label>
          <div className="mt-1 flex space-x-4">
            <label className="inline-flex items-center">
              <input
                disabled={readonly}
                type="radio"
                name="bwtsHasUSCGApproval"
                value="yes"
                checked={form.bwtsHasUSCGApproval === "yes"}
                onChange={handleChange}
                className="form-radio"
              />
              <span className="ml-2">Yes</span>
            </label>
            <label className="inline-flex items-center">
              <input
                disabled={readonly}
                type="radio"
                name="bwtsHasUSCGApproval"
                value="no"
                checked={form.bwtsHasUSCGApproval === "no"}
                onChange={handleChange}
                className="form-radio"
              />
              <span className="ml-2">No</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
